import { render } from "./HeroiconsSolidArrowsExpand.vue?vue&type=template&id=7458b5c2"
const script = {}

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidArrowsExpand.vue"]])

export default __exports__